const activateMhhBrand = (root) => {
  if (!(root instanceof HTMLElement)) return;

  document.body.classList.add('mhh-brand-active');

  const headerGroup = document.querySelector('#header-group');
  const cartSlot = root.querySelector('[data-mhh-cart-slot]');
  const nativeCart = headerGroup?.querySelector('cart-drawer-component');
  const fallback = root.querySelector('[data-mhh-cart-fallback]');

  if (cartSlot instanceof HTMLElement && nativeCart instanceof HTMLElement && !cartSlot.contains(nativeCart)) {
    cartSlot.append(nativeCart);
    fallback?.setAttribute('hidden', '');
  }

  if (root.parentElement !== document.body) {
    document.body.insertBefore(root, document.body.firstElementChild);
  }

  const toggle = root.querySelector('[data-mhh-menu-toggle]');
  const navigation = root.querySelector('[data-mhh-navigation]');

  if (toggle instanceof HTMLButtonElement && navigation instanceof HTMLElement && toggle.dataset.mhhBound !== 'true') {
    toggle.dataset.mhhBound = 'true';
    toggle.addEventListener('click', () => {
      const open = navigation.dataset.open !== 'true';
      navigation.dataset.open = String(open);
      toggle.setAttribute('aria-expanded', String(open));
    });

    navigation.addEventListener('click', (event) => {
      if (!(event.target instanceof HTMLAnchorElement)) return;
      navigation.dataset.open = 'false';
      toggle.setAttribute('aria-expanded', 'false');
    });
  }
};

const sanitizeMhhDescription = (description) => {
  if (!(description instanceof HTMLElement)) return;

  const normalized = (description.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  const sentences = normalized.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [];
  const obsoleteClaim =
    /free\s+(?:ground\s+)?shipping|orders?\s+(?:over|of)\s+\$?(?:40|50)|mikeshothoney\.com|ewingathletics\.com|starter\.com|(?:available|shop|buy)\s+(?:at|from|on)\s+(?:https?:\/\/|www\.|mike(?:'|’)?s\s+hot\s+honey)/i;
  const cleaned = sentences
    .filter((sentence) => !obsoleteClaim.test(sentence))
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();

  description.textContent = cleaned;
  description.parentElement?.toggleAttribute('hidden', cleaned.length === 0);
};

const updateMhhVariant = (productRoot, select, updateUrl = false) => {
  if (!(productRoot instanceof HTMLElement) || !(select instanceof HTMLSelectElement)) return;

  const option = select.selectedOptions[0];
  if (!(option instanceof HTMLOptionElement)) return;

  const formComponent = productRoot.querySelector('product-form-component');
  const variantInput = formComponent?.querySelector('[data-mhh-variant-id]');
  const price = productRoot.querySelector('[data-mhh-product-price]');
  const compare = productRoot.querySelector('[data-mhh-product-compare]');
  const availability = productRoot.querySelector('[data-mhh-product-availability]');
  const addButton = formComponent?.querySelector('button[ref="addToCartButton"]');
  const addButtonText = addButton?.querySelector('.add-to-cart-text__content > span > span');
  const addButtonContainer = formComponent?.querySelector('add-to-cart-component');
  const quantity = formComponent?.querySelector('input[name="quantity"]');
  const available = option.dataset.available === 'true';

  if (variantInput instanceof HTMLInputElement) variantInput.value = option.value;
  if (price instanceof HTMLElement) price.textContent = option.dataset.price || '';

  if (compare instanceof HTMLElement) {
    compare.textContent = option.dataset.compare || '';
    compare.toggleAttribute('hidden', !option.dataset.compare);
  }

  if (availability instanceof HTMLElement) {
    availability.textContent = available
      ? productRoot.dataset.mhhInStockLabel || 'In stock'
      : productRoot.dataset.mhhOutOfStockLabel || 'Out of stock';
    availability.dataset.available = String(available);
  }

  if (addButton instanceof HTMLButtonElement) addButton.disabled = !available;
  if (addButtonText instanceof HTMLElement) {
    addButtonText.textContent = available
      ? productRoot.dataset.mhhAddLabel || 'Add to cart'
      : productRoot.dataset.mhhSoldLabel || 'Sold out';
  }

  if (addButtonContainer instanceof HTMLElement) {
    addButtonContainer.dataset.productVariantMedia = option.dataset.mediaUrl || '';
  }

  if (quantity instanceof HTMLInputElement) {
    const minimum = option.dataset.quantityMin || '1';
    quantity.min = minimum;
    quantity.step = option.dataset.quantityIncrement || '1';
    quantity.value = minimum;
    if (option.dataset.quantityMax) quantity.max = option.dataset.quantityMax;
    else quantity.removeAttribute('max');
    if (formComponent instanceof HTMLElement) formComponent.dataset.quantityDefault = minimum;
  }

  const mediaId = option.dataset.mediaId;
  for (const media of productRoot.querySelectorAll('[data-media-id]')) {
    const isCurrent = Boolean(mediaId) && media.getAttribute('data-media-id') === mediaId;
    media.toggleAttribute('data-mhh-media-current', isCurrent);
    media.setAttribute('aria-current', isCurrent ? 'true' : 'false');
  }

  if (updateUrl) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState(window.history.state, '', url);
  }
};

const activateMhhProducts = (scope = document) => {
  const roots = [];
  if (scope instanceof Element && scope.matches('.mhh-product')) roots.push(scope);
  roots.push(...scope.querySelectorAll('.mhh-product'));

  for (const productRoot of roots) {
    if (!(productRoot instanceof HTMLElement)) continue;

    sanitizeMhhDescription(productRoot.querySelector('[data-mhh-product-description]'));

    const select = productRoot.querySelector('[data-mhh-variant-select]');
    if (!(select instanceof HTMLSelectElement)) continue;

    updateMhhVariant(productRoot, select);
    if (select.dataset.mhhBound === 'true') continue;

    select.dataset.mhhBound = 'true';
    select.addEventListener('change', () => updateMhhVariant(productRoot, select, true));
  }
};

const initializeMhhBrand = () => {
  const root = document.querySelector('.mhh-brand-shell');
  activateMhhBrand(root);
  activateMhhProducts();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMhhBrand, { once: true });
} else {
  initializeMhhBrand();
}

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target instanceof Element ? event.target.querySelector('.mhh-brand-shell') : null;
  activateMhhBrand(root || document.querySelector('.mhh-brand-shell'));
  if (event.target instanceof Element) activateMhhProducts(event.target);
});
